import { SpinnerOverlay } from "components/molecules/SpinnerOverlay";
import React from "react";

interface IBasePageProps {
  loading: boolean;
  children: React.ReactNode;
}

const BasePage: React.FC<IBasePageProps> = (props) => {
  const { loading, children } = props;
  return (
    <div>
      {children}
      <SpinnerOverlay show={loading} />
    </div>
  );
};

export default BasePage;
